export default __webpack_public_path__ + "static/media/securety.bd6a4622.svg";